import { useEffect } from "react";
import { readToken } from "../../api/client";
import { navigate, useLocation } from "../../router/useRoute";
import { CheckoutPage } from "./CheckoutPage";
import { EmailActionPage } from "./EmailActionPage";
import { GoogleCallbackPage } from "./GoogleCallbackPage";
import { LandingPage } from "./LandingPage";
import { LegalPage } from "./LegalPage";
import { LoginPage } from "./LoginPage";
import { ReferralLandingPage } from "./ReferralLandingPage";
import { RegisterPage } from "./RegisterPage";
import { ResetPasswordPage } from "./ResetPasswordPage";
import { VerifyEmailPage } from "./VerifyEmailPage";

export function PublicApp() {
  const { pathname, route } = useLocation();
  const authenticated = Boolean(readToken());

  useEffect(() => {
    // Đã đăng nhập mà vào lại trang đăng nhập hay trang giới thiệu thì đưa thẳng vào console.
    // Hỏi giá khi đã đăng nhập thì sang đúng trang gói cước của mình.
    if (authenticated && route === "landing" && pathname.replace(/\/+$/, "") === "/pricing") navigate("/member/packages", { replace: true });
    else if (authenticated && (route === "login" || route === "landing")) navigate("/member", { replace: true });
  }, [authenticated, pathname, route]);

  switch (route) {
    case "landing":
      return <LandingPage />;
    case "register":
      return <RegisterPage />;
    case "google-callback":
      return <GoogleCallbackPage />;
    case "referral":
      return <ReferralLandingPage />;
    case "resend-verification":
      return <EmailActionPage mode="resend-verification" />;
    case "forgot-password":
      return <EmailActionPage mode="forgot-password" />;
    case "verify-email":
      return <VerifyEmailPage />;
    case "reset-password":
      return <ResetPasswordPage />;
    case "legal":
      return <LegalPage />;
    case "checkout":
      return <CheckoutPage />;
    default:
      return <LoginPage />;
  }
}
